/* =========================================================================
   Premium color variant → gallery image filtering
   When a color variant is selected, only the product images whose ALT text
   matches the chosen color are shown in the gallery; all others are hidden.
   Works alongside the theme's existing (Swiper based) media gallery.
   ========================================================================= */
(function () {
  'use strict';

  function galleryFor(input) {
    var el = input;
    while (el && el !== document.body) {
      if (el.querySelector) {
        var g = el.querySelector('.product-media-gallery');
        if (g) return g;
      }
      el = el.parentElement;
    }
    return document.querySelector('.product-media-gallery');
  }

  function slideAlt(slide) {
    var img = slide.querySelector('img');
    return img ? (img.getAttribute('alt') || '').trim().toLowerCase() : '';
  }

  function mainSlides(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.swiper-main > .swiper-wrapper > .swiper-slide')
    );
  }

  function thumbSlides(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.swiper-thumbs > .swiper-wrapper > .swiper-slide')
    );
  }

  function applyFilter(gallery, color) {
    if (!gallery) return;
    color = (color || '').trim().toLowerCase();

    var main = mainSlides(gallery);
    var thumbs = thumbSlides(gallery);
    if (!main.length) return;

    // Does any image actually match this color? If not, keep everything visible.
    var anyMatch = false;
    if (color) {
      anyMatch = main.some(function (s) {
        return slideAlt(s).indexOf(color) !== -1;
      });
    }

    var firstVisible = 0;
    var foundVisible = false;
    main.forEach(function (s, i) {
      var visible = !color || !anyMatch || slideAlt(s).indexOf(color) !== -1;
      s.setAttribute('data-variant-hidden', visible ? 'false' : 'true');
      if (visible && !foundVisible) {
        firstVisible = i;
        foundVisible = true;
      }
    });

    // Keep thumbnails in sync with the main slides (identical media order)
    thumbs.forEach(function (s, i) {
      var ref = main[i];
      var hidden = ref ? ref.getAttribute('data-variant-hidden') === 'true' : false;
      s.setAttribute('data-variant-hidden', hidden ? 'true' : 'false');
    });

    // Refresh the Swiper instances so the layout reflows instantly
    try {
      var mainEl = gallery.querySelector('.swiper-main');
      var thumbsEl = gallery.querySelector('.swiper-thumbs');
      if (mainEl && mainEl.swiper) {
        mainEl.swiper.update();
        mainEl.swiper.slideTo(firstVisible, 0);
      }
      if (thumbsEl && thumbsEl.swiper) {
        thumbsEl.swiper.update();
      }
    } catch (e) { /* gallery not ready yet — ignore */ }
  }

  function selectedColor(input) {
    // Read the currently checked swatch within the same color group
    var name = input.getAttribute('name');
    var checked = document.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : input.value;
  }

  function onColorChange(e) {
    var input = e.target;
    if (!input.matches('.color-swatches input[type="radio"]')) return;
    var gallery = galleryFor(input);
    // Swiper may not be initialised on the very first tick — retry briefly.
    var tries = 0;
    (function run() {
      var mainEl = gallery && gallery.querySelector('.swiper-main');
      if (mainEl && mainEl.swiper) {
        applyFilter(gallery, selectedColor(input));
      } else if (tries++ < 20) {
        requestAnimationFrame(run);
      } else {
        applyFilter(gallery, selectedColor(input)); // fall back: still hide via CSS
      }
    })();
  }

  document.addEventListener('change', onColorChange);

  // Apply the initial filter for the pre-selected colour once galleries exist.
  function initAll() {
    document.querySelectorAll('.color-swatches input[type="radio"]:checked').forEach(function (input) {
      var gallery = galleryFor(input);
      if (gallery) applyFilter(gallery, selectedColor(input));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initAll, 400); });
  } else {
    setTimeout(initAll, 400);
  }
})();


/* =========================================================================
   "The Fabric" page — scroll reveal + count-up (CSS-first, tiny JS)
   ========================================================================= */
(function () {
  'use strict';
  if (window.__fabricInit) return;
  window.__fabricInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-fabric-count'));
    if (isNaN(target)) return;
    var decimals = (el.getAttribute('data-fabric-decimals') | 0);
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(decimals);
    }
    requestAnimationFrame(step);
  }

  function init() {
    var animated = Array.prototype.slice.call(document.querySelectorAll('.fabric-animate:not(.is-visible), .about-animate:not(.is-visible)'));
    var counters = Array.prototype.slice.call(document.querySelectorAll('[data-fabric-count]'));

    if (reduce || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) { el.classList.add('is-visible'); });
      counters.forEach(function (el) {
        var t = parseFloat(el.getAttribute('data-fabric-count'));
        if (!isNaN(t)) el.textContent = t.toFixed(el.getAttribute('data-fabric-decimals') | 0);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.hasAttribute('data-fabric-count')) countUp(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    animated.forEach(function (el) { io.observe(el); });
    counters.forEach(function (el) { if (!el.classList.contains('fabric-animate')) io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when the theme editor re-renders a section, otherwise freshly
  // injected reveal elements stay stuck at opacity 0 while customizing.
  document.addEventListener('shopify:section:load', init);
})();

/* =========================================================================
   Header: transparent-on-homepage + solid-on-scroll + on-scroll menu bar.
   Adds `is-scrolled` to #header-group once the page is scrolled, and
   `header-overlay` when the navbar is in transparent mode (homepage). All
   visual behaviour is driven from CSS via those classes (see custom.css).
   ========================================================================= */
(function () {
  'use strict';

  function initHeader() {
    var header = document.getElementById('header-group');
    if (!header) return;

    var transparentNav = header.querySelector('#navbar-wrapper.navbar-transparent');
    if (transparentNav) {
      header.classList.add('header-overlay');
      var color = transparentNav.style.getPropertyValue('--nav-transparent-color');
      if (color) header.style.setProperty('--nav-transparent-color', color);
    }

    var threshold = 10;
    var ticking = false;

    function update() {
      if (window.scrollY > threshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();
